import Vue from '@/setup'
import store from '@/store'

import CobrowseWidget from '@/modules/CobrowseWidget/components/CobrowseWidget'

const widgets = document.querySelectorAll('.cobrowseWidget')

widgets.forEach(el => {
  const props = el.dataset

  return new CobrowseWidget({
    el,
    propsData: { ...props },
    store,
    i18n: Vue.prototype.i18n
  })
})